import { Injectable, inject } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from './auth.service';
import { ConfigService } from 'src/app/core/services/config-service';
import { UserNotification } from '../models/notification.model';

@Injectable({
  providedIn: 'root',
})
export class BusinessSignalrService {
  connection: any;

  offerCreated: BehaviorSubject<number>;
  offerClosed: BehaviorSubject<number>;
  notificationReceived: BehaviorSubject<UserNotification | null>;

  constructor(public authService: AuthService) {
    this.offerCreated = new BehaviorSubject<number>(0);
    this.offerClosed = new BehaviorSubject<number>(0);
    this.notificationReceived = new BehaviorSubject<UserNotification | null>(null);
  }

  configService = inject(ConfigService);

  public async initiateSignalrConnection() {
    const isAuth = this.authService.isAuthenticated();
    if (!isAuth) {
      return;
    }

    try {
      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(this.configService.readConfig().baseUrlBusiness + '/realtime', { skipNegotiation: true, transport: signalR.HttpTransportType.WebSockets })
        .withAutomaticReconnect()
        .withHubProtocol(new signalR.JsonHubProtocol())
        .build();

      this.setSignalrClientMethods();

      await this.connection.start({ withCredentials: true });

      console.log(
        `SignalR connection success! connectionId: ${this.connection.connectionId}`
      );
    } catch (error) {
      console.log(`SignalR connection error: ${error}`);
    }
  }

  private setSignalrClientMethods(): void {
    this.connection.on('OfferCreated', (itemId: number) => {
      this.offerCreated.next(itemId);
    });

    this.connection.on('OfferClosed', (itemId: number) => {
      this.offerClosed.next(itemId);
    });

    this.connection.on('NotificationReceived', (notification: UserNotification) => {
      this.notificationReceived.next(notification);
    });
  }
}
